import { render, staticRenderFns } from "./variables-item.vue?vue&type=template&id=5a05502e&"
import script from "./variables-item.vue?vue&type=script&lang=js&"
export * from "./variables-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports